"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Input = exports.Icon = exports.Container = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _utils = require("../../utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var Container = _styledComponents["default"].div.withConfig({
  displayName: "Inputstyle__Container",
  componentId: "a39t0a-0"
})({
  position: 'relative'
});

exports.Container = Container;

var Icon = _styledComponents["default"].svg.withConfig({
  displayName: "Inputstyle__Icon",
  componentId: "a39t0a-1"
})(function (_ref) {
  var _ref$theme = _ref.theme,
      spacing = _ref$theme.spacing,
      color = _ref$theme.color,
      position = _ref.position;
  return {
    transition: '0.3s fill',
    display: 'block',
    position: 'absolute',
    top: 0,
    left: position === 'left' ? 0 : 'unset',
    right: position === 'right' ? 0 : 'unset',
    fill: color.neutral['03'],
    padding: "0 ".concat(spacing.inline['4xs']),
    width: 20,
    height: '100%',
    pointerEvents: 'none'
  };
});

exports.Icon = Icon;

var Input = _styledComponents["default"].input.withConfig({
  displayName: "Inputstyle__Input",
  componentId: "a39t0a-2"
})(function (_ref2) {
  var _notErrorFocus;

  var theme = _ref2.theme,
      paddingLeft = _ref2.paddingLeft,
      paddingRight = _ref2.paddingRight;
  return _extends({
    transition: '0.3s',
    boxSizing: 'border-box',
    border: "1px solid ".concat(theme.color.neutral['04']),
    borderRadius: theme.border.radius['3xs'],
    background: theme.color.neutral['07'],
    height: theme.spacing.inline['5xl'],
    outline: 'none',
    width: '100%',
    color: theme.color.neutral['02'],
    paddingLeft: paddingLeft ? theme.spacing.inline.xl : theme.spacing.inline['4xs'],
    paddingRight: paddingRight ? theme.spacing.inline.xl : theme.spacing.inline['4xs']
  }, (0, _utils.getTextStyle)({
    theme: theme,
    variant: 'body02-sm',
    margin: false
  }), {
    '&.error': _defineProperty({
      border: "1px solid ".concat(theme.color.feedback.error),
      color: theme.color.feedback.error
    }, "~ ".concat(Icon), {
      fill: theme.color.feedback.error
    }),
    '::placeholder': {
      transition: '0.3s color',
      color: theme.color.neutral['02']
    },
    ':not(.error):focus': (_notErrorFocus = {
      border: "1px solid ".concat(theme.color.brandPrimary.light),
      color: theme.color.brandPrimary.light
    }, _defineProperty(_notErrorFocus, "~ ".concat(Icon), {
      fill: theme.color.brandPrimary.light
    }), _defineProperty(_notErrorFocus, '::placeholder', {
      color: theme.color.brandPrimary.light
    }), _notErrorFocus)
  });
});

exports.Input = Input;